import { http, mailtoLink } from "@/lib/erp";
import { toast } from "sonner";

const money = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function billMessage(d, o) {
  const name = d[o.nameKey] || "Customer";
  const total = money(d[o.totalKey]);
  let m = `Dear ${name},\n\n${o.label} ${d[o.noKey]} — Amount: ${total}.`;
  if (d.balance_due > 0) m += `\nBalance due: ${money(d.balance_due)}.`;
  m += `\n\nThank you for your business.`;
  return m;
}

// Fetch the full document, then review it in the ERP before submitting to WhatsApp.
export async function shareBillWhatsApp(fetchUrl, o, requestSend) {
  const companyId = localStorage.getItem("vg_company");
  try {
    const { data } = await http.get(fetchUrl);
    const phone = data[o.phoneKey];
    let message = billMessage(data, o);
    if (o.publicInvoice) {
      const { data: share } = await http.post(`${fetchUrl}/share`);
      if (!share?.token) throw new Error("Invoice share link is unavailable");
      message += `\n\nView invoice: ${window.location.origin}/p/invoice/${share.token}`;
    }
    requestSend({ phone, message, title: `${o.label} ${data[o.noKey]}`, companyId });
  } catch (e) { toast.error("Could not load document to share"); }
}

export async function shareBillEmail(fetchUrl, o) {
  try {
    const { data } = await http.get(fetchUrl);
    const email = data[o.emailKey];
    if (!email) return toast.error("No email saved for this party");
    window.location.href = mailtoLink(email, `${o.label} ${data[o.noKey]}`, billMessage(data, o));
  } catch (e) { toast.error("Could not load document to share"); }
}
